<template>
  <b-dropdown variant="link" menu-class="nav-item notification-box dropdown" class="no-after">
    <template #button-content>
      <div class="nav-item notification-box dropdown">
        <div class="nav-link dropdown-toggle">
          <div class="notification-btn" @click="fetchAgain">
            <i class="bx bx-arrow-to-bottom"></i>
            <!-- <span v-if="count > 0" class="badge badge-secondary">{{ count }}</span> -->
          </div>
        </div>
      </div>
    </template>
    <div class="dropdown-header d-flex justify-content-between align-items-center">
      <span class="title d-inline-block">{{ items.count }} file</span>
      <!-- <span @click="readAll" class="mark-all-btn d-inline-block">Đánh dấu đã đọc</span> -->
    </div>
    <div class="dropdown-body py-0 height-fixed-245" style="min-width: 331px">
      <div v-if="items.length === 0" class="text-center">
        <img src="@/assets/img/no-noti.png" width="185px" />
        <p class="text-center d-block py-2 pb-3">
          <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
          <span class="cursor" @click="fetchData" v-else>Tải lại</span>
        </p>
      </div>
      <a
        href="javascript:;"
        class="dropdown-item d-flex align-items-center"
        v-for="item in items.exportRes"
        :class="item.mark ? 'read' : 'unread'"
        :key="item.id"
      >
        <ComponentDownloadFile :item="item" @fetchData="fetchAgain" />
      </a>
      <p class="text-center d-block py-2 pb-3">
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <span class="cursor" @click="fetchMore" v-else>Xem thêm</span>
      </p>
    </div>
  </b-dropdown>
</template>

<script>
  import ComponentDownloadFile from './ComDownLoadFile.vue'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import 'moment/locale/vi'
  import Config from '@/thirdParty/config'
  moment.locale('vi')
  export default {
    props: {},
    data() {
      return {
        Config,
        items: [],
        limit: 10,
        count: 0,
        oldCount: 0,
        loading: true,
        myInterval: {},
        sseData: 11,
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },
    components: { ComponentDownloadFile },
    async created() {
      this.fetchData()
    },
    beforeDestroy() {
      clearInterval(this.myInterval)
    },
    methods: {
      async countData() {
        const res = await CommonService.countNotificationUnread()
        this.count = res.data.count
        if (this.oldCount < this.count) {
          this.fetchData()
          this.loading = false
        }
      },
      async fetchData() {
        this.loading = true
        try {
          const res = await CommonService.getListFileExport({
            page: 1,
            limit: this.limit,
          })
          this.items = res.data
          this.count = res.data.count
          this.oldCount = this.count
        } catch (error) {
        } finally {
          this.loading = false
        }
      },
      fetchAgain() {
        this.limit = 10
        this.fetchData()
      },
      fetchMore() {
        this.limit += 10
        this.fetchData()
      },
      async readFile(id, bearerToken) {
        try {
          const sseClient = await fetch(`https://mynextpay.nextshop.dev/file/export/get-list`, {
            headers: {
              Authorization: bearerToken,
              Accept: 'text/event-stream',
            },
          })
          if (!sseClient.ok) {
            throw Error(sseClient.statusText())
          }

          for (const reader = sseClient.body.getReader(); ; ) {
            const { value, done } = await reader.read()
            if (done) {
              break
            }
            const chunk = new TextDecoder().decode(value)
            const payload = chunk.replace(/^data:/, '')
            if (payload.includes('SUCCESS')) {
              this.sseData = 'SUCCESS'
            } else this.sseData = Number(payload)
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
